
import { defineComponent, PropType } from "vue";

interface ReportOption {
    title: string;
    path: string;
    icon: string;
}

export default defineComponent({
    name: "ReportOptionComponent",
    props: {
        option: {
            type: Object as PropType<ReportOption>,
            required: true
        }
    },
    emits: ["click"],
    computed: {
        description(): string {
            const descriptions: Record<string, string> = {
                all: "جستجو، فیلتر و مشاهده اطلاعات کاربران",
                Identify: "بررسی درخواست‌های احراز هویت",
                Notifications: "ارسال پیام و اطلاع‌رسانی",
                logs: "پیگیری فعالیت‌ها و رویدادهای سامانه",
                commissions: "مشاهده کارمزدهای ثبت‌شده",
                depositTransferHistory: "بررسی گردش حساب سپرده",
                transactions: "جستجو و بررسی تراکنش‌ها",
                withdrawals: "رسیدگی به درخواست‌های تسویه",
                gateways: "مدیریت درگاه‌های کاربران",
                systemGateways: "پیکربندی درگاه‌های سیستمی",
                withdrawal: "بررسی و مدیریت تسویه‌های تتری",
                setting: "مدیریت تنظیمات صرافی",
                settings: "پیکربندی کارمزدهای سامانه",
                paymentSetting: "تنظیم روش و شرایط تسویه"
            };
            return descriptions[this.option.path] || "مشاهده و مدیریت اطلاعات";
        }
    }
});
